import { GetState } from 'zustand';
import budgetAmountDecisionByRole from '../../../../comps/contents/budget-amount-decision-by-role';
import getLedspClient from '../../../../utils/get-ledsp-client';
import { ICountdown } from '../../concepts/countdown';
import { IDocs } from '../../concepts/docs';
import { IGame } from '../../concepts/game';
import { IKpi } from '../../concepts/kpi';
import { ILocations } from '../../concepts/locations';
import { IPlayer } from '../../concepts/player';
import { IToDos, VotingPayload } from '../../concepts/to-dos';
import { IVoting } from '../../concepts/voting';
import { IPhaseExecutorFn } from '../game';

export const startPhase1Voting: IPhaseExecutorFn = (
  get: GetState<
    IGame & IDocs & IToDos & ILocations & IVoting & IPlayer & ICountdown & IKpi
  >
) => {
  get().closeLocation('/');
  get().closeMeeting();
  get().pinLocation('phases/phase-1/vote');
  get().openLocation('phases/phase-1/vote');

  get().clearToDos();
  ToDos.forEach(get().appendToDo);

  get().startVotingSession('phase-1', {
    availableVotes: get().availableBudgetVotes(),
    voters: get().players,
    isMotivationRequired: false,
  });

  get().appendToDo<VotingPayload>({
    id: 'vote-phase-1',
    type: 'vote',
    locationToVisit: 'phases/phase-1/vote',
    nudge: '',
    payload: {
      sessions: ['phase-1'],
      gotoPhase: 'phase-1-outcomes',
    },
  });

  get().startCountdown(get().currentPhaseStartTime, 5 * 60 * 1_000);

  getLedspClient().sendGameProgressEvent({
    step: 'Phase1',
    stage: 'Voting',
    gameId: get().gameId,
    playerId: get().playerId,
    teamId: get().team,
    eventType: 'game-stage-entered',
  });
};

const ToDos = [];
